import { useCallback } from 'react';
import useSubtitle from 'src/hooks/useSubtitle';
import { EVENT_TYPES } from 'src/interfaces/enums';
import ApplicationService from 'src/services/ApplicationService';

function useNotifyEvents() {
  const { notifySubtitleChange } = useSubtitle();

  const createNotifyListeners = useCallback(() => {
    ApplicationService.player?.addEventListener(EVENT_TYPES.SUBTITLE_CHANGE, notifySubtitleChange);
  }, []);

  return { createNotifyListeners };
}

export default useNotifyEvents;
